import { render } from "./Appointments.vue?vue&type=template&id=667d4cd0&scoped=true"
import script from "./Appointments.vue?vue&type=script&lang=js"
export * from "./Appointments.vue?vue&type=script&lang=js"

import "./Appointments.vue?vue&type=style&index=0&id=667d4cd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-667d4cd0"

export default script